const CHUNK_RELOAD_KEY = 'supermeta_chunk_reload_at'
const CHUNK_RELOAD_COOLDOWN_MS = 10000

const CHUNK_ERROR_MESSAGES = [
  'Loading chunk',
  'ChunkLoadError',
  'Failed to fetch dynamically imported module',
  'error loading dynamically imported module',
  'Importing a module script failed',
  'Unable to preload CSS',
]

const isChunkErrorMessage = (message: string) =>
  CHUNK_ERROR_MESSAGES.some(pattern => message.includes(pattern))

const isAssetLoadError = (event: ErrorEvent | Event) => {
  const target = event.target
  if (!(target instanceof HTMLScriptElement) && !(target instanceof HTMLLinkElement)) return false

  const url = target instanceof HTMLScriptElement ? target.src : target.href
  return url.includes('/assets/') && (url.endsWith('.js') || url.endsWith('.css'))
}

const reloadOnce = () => {
  const lastReloadAt = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY) ?? 0)
  const now = Date.now()

  if (now - lastReloadAt < CHUNK_RELOAD_COOLDOWN_MS) return

  sessionStorage.setItem(CHUNK_RELOAD_KEY, String(now))
  window.location.reload()
}

const getErrorMessage = (event: ErrorEvent) => {
  const error = event.error
  return [
    event.message,
    error instanceof Error ? error.name : '',
    error instanceof Error ? error.message : '',
  ].join(' ')
}

const getRejectionMessage = (event: PromiseRejectionEvent) => {
  const reason = event.reason
  if (reason instanceof Error) return `${reason.name} ${reason.message}`
  return String(reason ?? '')
}

export const installChunkReloadHandler = () => {
  window.addEventListener(
    'error',
    event => {
      if (isAssetLoadError(event) || isChunkErrorMessage(getErrorMessage(event))) {
        reloadOnce()
      }
    },
    true
  )

  window.addEventListener('unhandledrejection', event => {
    if (isChunkErrorMessage(getRejectionMessage(event))) {
      reloadOnce()
    }
  })
}
